import type { SessionArtwork, SessionArtworkFavoriteState } from '@modelcast/types';

export function applyArtworkFavoriteState(
  artwork: SessionArtwork,
  favorites: Record<string, SessionArtworkFavoriteState>,
  participantId: string
): SessionArtwork {
  const favoriteState = favorites[artwork.id];
  if (!favoriteState) return artwork;

  return {
    ...artwork,
    likesCount: favoriteState.likesCount,
    isLikedByMe: favoriteState.likedByParticipantIds.includes(participantId),
  };
}
